import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { SetWeightActionStep } from "@redotech/redo-flows-common/oms/actions";
import { WeightFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { Weight } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { TotalWeightWidget } from "@redotech/redo-merchant-app-common/components/weight-widget/total-weight-widget";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { PartialWithRequiredType } from ".";

export const WeightInput = memo(function WeightInput({
  step,
  setStep,
}: {
  step: PartialWithRequiredType<SetWeightActionStep>;
  setStep: (step: PartialWithRequiredType<SetWeightActionStep>) => void;
}) {
  const team = useRequiredContext(TeamContext);
  const onWeightChange = useHandler((weight: Weight) => {
    setStep({ ...step, weight });
  });

  // Convert step.weight to a Weight object
  const currentWeight =
    step.weight && step.weight.unit && step.weight.value
      ? { unit: step.weight.unit as WeightUnit, value: step.weight.value }
      : { unit: WeightUnit.Oz, value: 0 };

  return (
    <Flex align="stretch" dir="column" flex={1}>
      <TotalWeightWidget
        disabled={false}
        onWeightChange={onWeightChange}
        weight={currentWeight}
        weightFormat={
          team?.settings?.outboundLabels?.weightFormat ?? WeightFormat.IMPERIAL
        }
      />
    </Flex>
  );
});
